module.exports = __webpack_public_path__ + "img/pest_control.915711e2.jpg";